module.exports = __webpack_public_path__ + "static/media/zolePlayed_250000_500000.9f1bb8d4.png";